// generate a randome encrypted string
export const USER_ID = "U2FsdGVkX1+3";
export const CLIENT_ID = "U2FsdGVkX1+4";
export const ACCESS_TOKEN = "U2FsdGVkX1+5";
